import * as PIXI from 'pixi.js';
import { state } from "__common/store";
import { measurementToolModel } from "__editor/googleMapsRoofsSelector/models/measurementTool";
import { getPixiLayer } from "../stage/stage";

let measurementContainer: PIXI.Container;

export const renderMeasurementTool = () => {
  const { measurementTool: { enabled, visible, startingPoint, endingPoint, measurements }, projectConfiguration: { productId, inputUnit } } = state();
  const pixiLayer: any = getPixiLayer();
  if (!pixiLayer) return;

  const stage = pixiLayer.stage;
  const scale = stage.scale.x;

  if (!measurementContainer || measurementContainer.destroyed) {
    measurementContainer = new PIXI.Container();
    measurementContainer.id = 'measurementTool';
    measurementContainer.sortableChildren = true;
  }

  // The map stage sorts children. Without this, lines render under roofs.
  measurementContainer.zIndex = 99999;
  measurementContainer.name = 'measurementToolLayer';
  measurementContainer.eventMode = 'none';
  measurementContainer.interactiveChildren = false;

  if (measurementContainer.parent !== stage) {
    stage.addChild(measurementContainer);
  }

  // Clear old elements
  measurementContainer.removeChildren();

  if (!visible) {
    pixiLayer.rerender();
    return;
  }

  measurements.forEach((measurement, index) => {
    const measurementModel = measurementToolModel(measurement.startingPoint, measurement.endingPoint, scale, productId, inputUnit, false, 0, index);
    measurementContainer.addChild(measurementModel);
  });

  if (enabled && startingPoint && endingPoint) {
    const measurementPreview = measurementToolModel(startingPoint, endingPoint, scale, productId, inputUnit, false, 0);
    measurementContainer.addChild(measurementPreview);
  }

  pixiLayer.rerender();
};
